import { render } from "./file-manager-deleted.vue?vue&type=template&id=4db1b5ee"
import script from "./file-manager-deleted.vue?vue&type=script&lang=js"
export * from "./file-manager-deleted.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__